import { useCurrentAccountQuery } from "../../api/queries/useAccountQuery";
import { ACCOUNT_TYPE } from "../../consts/api";

export const useRestrictions = () => {
  const { data, isLoading } = useCurrentAccountQuery();

  const restrictions = {
    isAccountTypePaid: data?.type === ACCOUNT_TYPE.paid,
  };

  return {
    ...restrictions,
    isLoading,
  };
};
